import { render } from "./AppSelectFieldWithObject.vue?vue&type=template&id=212b6773&scoped=true"
import script from "./AppSelectFieldWithObject.vue?vue&type=script&lang=js"
export * from "./AppSelectFieldWithObject.vue?vue&type=script&lang=js"

import "./AppSelectFieldWithObject.vue?vue&type=style&index=0&id=212b6773&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212b6773"]])

export default __exports__